// src/components/music/views/MobileListView.jsx

import { motion } from 'framer-motion';
import { MobileTrackRow } from '../parts/MobileTrackRow';

export const MobileListView = ({
  filteredMusic,
  currentTrack,
  isPlaying,
  playQueue,
  onPlayPause,
  onPurchase,
  processingPayment,
  onAddToPlaylist,
  currentUser,
  isPurchased,
  onDownload
}) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="flex flex-col gap-1.5 mb-8"
    >
      {filteredMusic.map((track, index) => (
        <MobileTrackRow
          key={track.id}
          track={track}
          index={index}
          isCurrent={currentTrack?.id === track.id}
          isPlaying={isPlaying}
          playQueue={playQueue}
          onPlayPause={onPlayPause}
          onPurchase={onPurchase}
          processingPayment={processingPayment}
          onAddToPlaylist={onAddToPlaylist}
          currentUser={currentUser}
          isPurchased={isPurchased}
          onDownload={onDownload}
        />
      ))}
    </motion.div>
  );
};
